import styled from 'styled-components';

export const Separator = styled.span`
  &::after {
    content: '·';
    margin: 0 var(--spacing-02);
  }
`;
